// =======================
// src/estilos/botoes.js
// =======================

import { ajustarTamanhoFonteAdmin } from "./global";

// =========================================================
// BASE GLOBAL DOS BOTÕES TEXTUAIS
// =========================================================

const botaoBase = {
  minHeight: 38,
  px: 2.4,

  borderRadius: 1.25,

  fontFamily: "inherit",
  fontSize: ajustarTamanhoFonteAdmin("0.875rem"),
  fontWeight: 500,

  textTransform: "none",

  whiteSpace: "nowrap",

  boxShadow: "none",

  transition:
    "background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease",

  "&:focus-visible": {
    outline: "2px solid rgba(8, 124, 240, 0.28)",
    outlineOffset: 2,
  },

  "&.Mui-disabled": {
    color: "#94a3b8",
    borderColor: "#d6dee7",
    backgroundColor: "#f3f5f7",
    boxShadow: "none",
  },
};

// =========================================================
// BOTÃO PADRÃO
// =========================================================

export const botaoPadrao = {
  ...botaoBase,

  color: "#0767d8",

  border: "1px solid #9fc8f2",

  backgroundColor: "#ffffff",

  "&:hover": {
    color: "#ffffff",

    borderColor: "#087cf0",

    backgroundColor: "#087cf0",

    boxShadow: "none",
  },

  "&:focus-visible": {
    outline: "2px solid rgba(8, 124, 240, 0.28)",
    outlineOffset: 2,
  },

  "&.Mui-disabled": {
    color: "#94a3b8",

    borderColor: "#d6dee7",

    backgroundColor: "#f3f5f7",

    boxShadow: "none",
  },
};

// =========================================================
// CANCELAR
// =========================================================

export const botaoCancelar = {
  ...botaoBase,

  color: "#c62828",

  border: "1px solid #e57373",

  backgroundColor: "#ffffff",

  "&:hover": {
    color: "#ffffff",

    borderColor: "#d32f2f",

    backgroundColor: "#d32f2f",

    boxShadow: "none",
  },

  "&:focus-visible": {
    outline: "2px solid rgba(211, 47, 47, 0.25)",
    outlineOffset: 2,
  },

  "&.Mui-disabled": {
    color: "#94a3b8",

    borderColor: "#d6dee7",

    backgroundColor: "#f3f5f7",

    boxShadow: "none",
  },
};

// =========================================================
// EXCLUIR
// =========================================================
//
// Ação destrutiva principal.
//
// O vermelho preenchido fica reservado para a confirmação
// efetiva de exclusão.
// =========================================================

export const botaoExcluir = {
  ...botaoBase,

  color: "#ffffff",

  border: "1px solid #d92f3d",

  backgroundColor: "#d92f3d",

  boxShadow: "0 2px 6px rgba(190, 35, 48, 0.18)",

  "&:hover": {
    color: "#ffffff",

    borderColor: "#bf2633",

    backgroundColor: "#bf2633",

    boxShadow: "0 3px 8px rgba(190, 35, 48, 0.24)",
  },

  "&:focus-visible": {
    outline: "2px solid rgba(211, 47, 47, 0.25)",
    outlineOffset: 2,
  },

  "&.Mui-disabled": {
    color: "#ffffff",

    borderColor: "#e6aeb4",

    backgroundColor: "#e6aeb4",

    boxShadow: "none",
  },
};

// =========================================================
// ALIASES SEMÂNTICOS
// =========================================================

export const botaoSalvar = {
  ...botaoPadrao,
};

export const botaoCriar = {
  ...botaoPadrao,
};

export const botaoConfirmar = {
  ...botaoPadrao,
};

export const botaoEditar = {
  ...botaoPadrao,
};

export const botaoVoltar = {
  ...botaoPadrao,
};

// =========================================================
// ADICIONAR / ANEXAR
// =========================================================

export const botaoAdicionar = {
  ...botaoBase,

  minHeight: 34,
  px: 2,

  borderRadius: 1,

  fontSize: ajustarTamanhoFonteAdmin("0.78rem"),
  fontWeight: 500,

  color: "#ffffff",

  border: "1px solid transparent",

  background: "linear-gradient(90deg, #0656ed, #0795f5)",

  boxShadow: "0 2px 6px rgba(7, 103, 216, 0.16)",

  transition:
    "background 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease",

  "&:hover": {
    color: "#ffffff",

    borderColor: "transparent",

    background: "linear-gradient(90deg, #064bd4, #0786df)",

    boxShadow: "0 3px 8px rgba(7, 103, 216, 0.2)",
  },

  "&:focus-visible": {
    outline: "2px solid rgba(8, 124, 240, 0.28)",
    outlineOffset: 2,
  },

  "&.Mui-disabled": {
    color: "#94a3b8",

    borderColor: "#d6dee7",

    background: "#f3f5f7",

    boxShadow: "none",
  },
};

export const botaoAnexar = {
  ...botaoAdicionar,
};

// =========================================================
// PAGINAÇÃO
// =========================================================

export const botaoAnterior = {
  ...botaoPadrao,

  minHeight: 34,

  px: 1.5,

  fontSize: ajustarTamanhoFonteAdmin("0.875rem"),

  whiteSpace: "nowrap",

  flexShrink: 0,
};

export const botaoSeguinte = {
  ...botaoAnterior,
};

// =========================================================
// ICONBUTTON — EDITAR
// =========================================================

export const botaoAcaoEditar = {
  width: 36,
  height: 36,

  color: "#087cf0",

  "&:hover": {
    color: "#0767d8",

    backgroundColor: "#eaf4ff",
  },

  "&.Mui-disabled": {
    color: "#aebdca",
  },
};

// =========================================================
// ICONBUTTON — EXCLUIR
// =========================================================

export const botaoAcaoExcluir = {
  width: 36,
  height: 36,

  color: "#d32f2f",

  "&:hover": {
    color: "#ffffff",

    backgroundColor: "#d32f2f",
  },

  "&.Mui-disabled": {
    color: "#aebdca",
  },
};
